/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { eventBus } from '../../utils/app-utils/event-bus';
import { WindowType } from '../../types/global-window-type';
import { t } from '../../utils/app-utils/translations';
import {
  getCACustomButtonElement,
  hideFloatingButton,
  showFloatingButton,
  updateFloatingButtonText,
} from '../../utils/button-utils/custom-button-utils';
import { launchChat } from '../../utils/sf-utils/chat-actions';
import { isHelpPanelAnywherePage, sendEventToHelpAnywherePanel } from '../../utils/help-panel-utils/help-panel-events';
import {
  isHelpCenterHomepage,
  isBannerPage,
  isStudioPage,
  isOrderHelpPage,
} from '../../utils/app-utils/page-specific-utils';
import { updatePPAGInlineButton } from '../../utils/button-utils/ppag-discover-page';
import { conflictingPageMapping } from '../../context/page-mapping';
import { addConflictingPageCSSClass, isPageConflicting } from '../../utils/button-utils/helper';
import { isChatSessionActive, removeChatSession, setChatSession } from '../../utils/sf-utils/chat-session';
import { handleStudioHelpPanel, populateLiveDesignLink } from '../../utils/help-panel-utils/studio-utils';
import {
  hideDesignHelpButton,
  isDesignPage,
  updateDesignButtonState,
} from '../../utils/button-utils/design-page-utils';
import { checkBusinessHours } from '../../utils/api-utils/gcp-api';
import { getLocaleDays } from '../../utils/sf-utils/helper';

declare const window: WindowType;
let isChatMaximized = false;
let isBackButtonClicked = false;
let isChatEnded = false;

export const onMaximize = () => {
  console.info('onMaximize');
  eventBus.dispatch('CAafterMaximize', {});
  isChatMaximized = true;

  /** Send Event to HP to hide Chat loading button and hide HP */
  if (isHelpPanelAnywherePage()) {
    sendEventToHelpAnywherePanel('hideChatLoader');
    sendEventToHelpAnywherePanel('hideHelpPanel');
    sessionStorage.removeItem('CAUnreadMessage');
  }

  /** If chat is opened, disable the inline button */
  isBannerPage().then((result) => {
    if (result && result.allowed && result.matchedStyle) {
      updatePPAGInlineButton(t('chatting-text'), true, result.matchedStyle);
    }
  });

  if (isDesignPage().isDesignpage) {
    /** For Design Page, update the button state */
    updateDesignButtonState(t('chatting-text'), true);
  }

  if (isStudioPage()) {
    isChatMaximized = true;
  }
  hideFloatingButton();
};

export const onMinimize = () => {
  console.info('onMinimize');

  if (isHelpPanelAnywherePage()) {
    if (isBackButtonClicked) {
      hideFloatingButton();
      isBackButtonClicked = false;
    } else {
      showFloatingButton();
    }
  } else {
    /** Show Button , add conflicting classes */
    showFloatingButton();
    const customButton = getCACustomButtonElement();
    if (customButton) {
      if (isPageConflicting()) {
        conflictingPageMapping.forEach((ele) => {
          addConflictingPageCSSClass(customButton, ele.pageName, ele.className);
        });
      }
    }
  }
};
export const onChatReady = async () => {
  console.info('onChatReady');
  const isConversationBrowserClosed = sessionStorage.getItem('isConversationBrowserClosed');
  if (isConversationBrowserClosed) {
    sessionStorage.removeItem('isConversationBrowserClosed');
  }
  /** Update Button to Chat Now once chat is ready */
  updateFloatingButtonText(t('ca-message'));

  window.isMiawChatReady = true;

  /** Check if Chat button is already clicked , if yes ,launch the chat */
  if (window.isChatNowClicked) {
    setTimeout(() => {
      delete window.isChatNowClicked;
      launchChat();
    }, 1000);
  }
  const chatData = await checkBusinessHours();
  const chatStatus = chatData?.status?.isChatEnabled;

  eventBus.dispatch('CAonChatInit', { isAgentAvailable: chatStatus });

  console.info('Chat Status on Ready', chatStatus);
  isBannerPage().then((result) => {
    if (result && result.allowed && result.matchedStyle) {
      updatePPAGInlineButton(t('start-chat'), !chatStatus, result.matchedStyle);
    }
  });

  if (isHelpPanelAnywherePage()) {
    /** For Help Panel, send event */
    sendEventToHelpAnywherePanel('hideChatScriptLoader');
    /** For Studio Page, check if chat window is closed, and show help panel */
    if (isStudioPage()) {
      populateLiveDesignLink();
      if (isChatMaximized) {
        handleStudioHelpPanel();
        isChatMaximized = false;
      } else {
        hideFloatingButton();
      }

      if (isChatEnded) {
        isChatEnded = false;
        hideFloatingButton();
        sendEventToHelpAnywherePanel('showHelpPanelButton');
      }
    }
  } else if (isDesignPage().isDesignpage) {
    const buttonText = t('ca-message');
    updateDesignButtonState(buttonText, !chatStatus);
    if (!chatStatus) {
      hideDesignHelpButton();
    }
    hideFloatingButton();
  } else if (isOrderHelpPage()) {
    hideFloatingButton();
  } else {
    /** To show once chat is closed */
    showFloatingButton();
  }
  /** If session is active on any page, show chat button */
  if (isChatSessionActive()) {
    showFloatingButton();
  }
};
export const onChatEnded = () => {
  console.info('onChatEnded');
};
export const onButtonClick = () => {
  console.info('onButtonClick');
};
export const onChatEstablished = () => {
  console.info('onChatEstablished');
  if (isHelpPanelAnywherePage()) {
    sendEventToHelpAnywherePanel('chatEstablished');
  }
};
export const onMessageSent = () => {
  console.info('onMessageSent');
};
export const onSessionContinuation = () => {
  console.info('onSessionContinuation');
  /** Set localStorage */
  setChatSession();
  /** Send Event for any external project using this event */
  eventBus.dispatch('CAonSessionActive', {});

  isBannerPage().then((result) => {
    if (result && result.allowed && result.matchedStyle) {
      updatePPAGInlineButton(t('chatting-text'), true, result.matchedStyle);
    }
  });

  if (isHelpPanelAnywherePage()) {
    if (!isChatMaximized) showFloatingButton();
    /** For Help Panel Pages */
    sendEventToHelpAnywherePanel('hideHelpPanel');
    sendEventToHelpAnywherePanel('hideChatScriptLoader');
    sendEventToHelpAnywherePanel('hideChatLoader');

    populateLiveDesignLink();
  } else if (isHelpCenterHomepage()) {
    /** For Help Center Homepage */
    /** in case the ca scripts are loaded before HC page, send the event after recieving event from HC */
    document.addEventListener('helpCenterCAEvent', () => {
      eventBus.dispatch('CAonSessionActive', {});
    });
  } else if (isDesignPage().isDesignpage) {
    /** Update for Design and Search Page */
    updateDesignButtonState(t('chatting-text'), true);
  } else {
    const customButton = getCACustomButtonElement();
    if (customButton) {
      if (isPageConflicting()) {
        conflictingPageMapping.forEach((ele) => {
          addConflictingPageCSSClass(customButton, ele.pageName, ele.className);
        });
      }
    }
  }
};
export const onChatTransfer = () => {
  console.info('onChatTransfer');
};
export const onChatEndedByUser = () => {
  removeChatSession();
  isChatEnded = true;
  console.info('onChatEndedByUser');
};

export const onBackButtonClick = () => {
  isBackButtonClicked = true;
  sendEventToHelpAnywherePanel('showHelpPanel');
  hideFloatingButton();
};

const DEFAULT_SCH = {
  weekday: '',
  endTime: '-',
  startTime: '-',
};

// Helper: get hour in given timeZone
function getHourInTimeZone(timeZone) {
  const formatter = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    hour12: false,
    timeZone,
  });
  return parseInt(formatter.format(new Date()), 10);
}

export const getSchedule = (data, timeZone, locale) => {
  try {
    const obj = DEFAULT_SCH;

    const currentDayIndex = new Date().getDay();
    const localeDays = getLocaleDays(locale);
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const currentDay = days[currentDayIndex];

    const getDaySchedule = (index) => {
      let daySchedule = DEFAULT_SCH;
      data.forEach((ele) => {
        if (ele.weekday === localeDays[index]) {
          daySchedule = ele;
        }
      });
      if (daySchedule && daySchedule.startTime?.length && daySchedule.startTime !== '-') {
        return daySchedule;
      }
      return undefined;
    };

    const currentDaySchedule = getDaySchedule(currentDay);

    if (currentDaySchedule) {
      const st = currentDaySchedule.startTime;
      if (st.length && st !== '-') {
        const currHour = getHourInTimeZone(timeZone || 'America/New_York');
        const startHour = parseInt(st.split(':')[0], 10);

        if (currHour <= startHour) return currentDaySchedule;
      }
    }

    let nextDayIndex = currentDayIndex + 1 > 6 ? 0 : currentDayIndex + 1;
    let nextDay = days[nextDayIndex];

    for (let count = 0; count < 7; count += 1) {
      const schedule = getDaySchedule(nextDay);
      if (schedule) return schedule;

      nextDayIndex = nextDayIndex > 6 ? 0 : nextDayIndex + 1;
      nextDay = days[nextDayIndex];
    }

    return obj;
  } catch (err) {
    console.error(err);
    return {
      endTime: '',
      startTime: '',
      weekday: '',
    };
  }
};
